export var simplifyAST = function (ast) {
    for (var i = ast.length - 1; i >= 0; i--) {
        ast[i] = simplifyMediaQuery(ast[i]);
    }
    return ast;
};
var simplifyMediaQuery = function (mediaQuery) {
    if (mediaQuery.mediaCondition === null)
        return mediaQuery;
    var mediaCondition = simplifyMediaCondition(mediaQuery.mediaCondition);
    if (mediaCondition.operator === null &&
        mediaCondition.children.length === 1 &&
        'children' in mediaCondition.children[0]) {
        mediaCondition = mediaCondition.children[0];
    }
    return {
        mediaPrefix: mediaQuery.mediaPrefix,
        mediaType: mediaQuery.mediaType,
        mediaCondition: mediaCondition
    };
};
var simplifyMediaCondition = function (mediaCondition) {
    for (var i = mediaCondition.children.length - 1; i >= 0; i--) {
        var unsimplifiedChild = mediaCondition.children[i];
        if (!('context' in unsimplifiedChild)) {
            var child = simplifyMediaCondition(unsimplifiedChild);
            if (child.operator === null && child.children.length === 1) {
                mediaCondition.children[i] = child.children[0];
            }
            else if (child.operator === mediaCondition.operator &&
                (child.operator === 'and' || child.operator === 'or')) {
                var spliceArgs = [i, 1];
                for (var i_1 = 0; i_1 < child.children.length; i_1++) {
                    spliceArgs.push(child.children[i_1]);
                }
                mediaCondition.children.splice.apply(mediaCondition.children, spliceArgs);
            }
        }
    }
    return mediaCondition;
};
//# sourceMappingURL=simplifyAST.js.map